import React from 'react'
import MapContainer from "../ui/map/map.container";
import SearchBarContainer from "../ui/search-bar/search-bar.container";
import CourtPopupContainer from "../ui/court-popup/court-popup.container";

const MapScreen: React.FC = () => {
  return (
    <div>
      <SearchBarContainer />
      <MapContainer />
      <CourtPopupContainer />
    </div>
  )
}

export default MapScreen
